import _ from 'underscore';

import { requestGet, } from '../../../modules/request/index';
import { splitInLevels, getParentName, } from '../../Shared/index'

import C from '../constants';

const conceptsEndpoint = `${window.postbuildEnv.DEFAULT_URL}/api/v1/concepts.json`;

const actions = {
  startListeningToConcepts() {
    return (dispatch) => {
      requestGet(conceptsEndpoint, (body) => {
        const concepts = splitInLevels(body.concepts);
        concepts['0'] = concepts['0'].map((concept) => {
          concept.displayName = `${getParentName(concept, concepts)} | ${concept.name}`;
          return concept;
        });
        dispatch({ type: C.RECEIVE_CONCEPTS_DATA, data: concepts, });
      });

    };
  },
};

export default actions;
